module.exports = __webpack_public_path__ + "static/media/student-item-block.9184f45e.png";